<template>
  <!-- Modal -->
  <div class="modal fade" id="CostBudgetYearModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('budget.add_new_fiscal_year') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <input type="text" min-value="1970" class="form-control" placeholder="2018" v-model="year">
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal" @click="setYear()">{{ translations('common.close') }}</button>
          <button type="button" class="btn btn-primary" @click="addYear()">{{ translations('budget.add') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'CostBudgetYearModal',
  components: {
    VueElementLoading
  },
  props: {},
  data () {
    return {
      year: 0,
      isSearching: false
    }
  },
  created () {
    this.setYear()
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    setYear () {
      this.year = (new Date()).getFullYear()
    },

    async addYear () {
      if (Number(this.year) <= 0) {
        this.$toastr.warning('年度を入力してください。')
        return
      }

      try {
        this.isSearching = true

        let paramUpdate = {
          year: this.year
        }
        console.log('CostBudget:addYear', JSON.stringify(paramUpdate))

        let addBudget = await this.$http.post(this.$api_url.cost_add_year, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(addBudget.data)

        console.log('CostBudget:addYear: ', JSON.stringify($data))
        if ($data.success === true) {
          this.$toastr.success('年度の追加に成功しました。', 'Success')
          this.$parent.addYear(Number(this.year))
          this.$refs['closeModal'].click()
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log('CostBudget:addYear:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    }
  }
}
</script>
